module.exports = __webpack_public_path__ + "static/img/bg_card.d0a903f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-hour-2026-sale/bg_card.gif
// module id = 6inQ
// module chunks = 2